export default __webpack_public_path__ + "89e987087262d028f06d71cd07a4ace6.png";